// Time Entries Action Types

// Get Time Entries List
export const GET_TIME_ENTRIES_LIST = "GET_TIME_ENTRIES_LIST";
export const GET_TIME_ENTRIES_LIST_SUCCESS = "GET_TIME_ENTRIES_LIST_SUCCESS";
export const GET_TIME_ENTRIES_LIST_FAILURE = "GET_TIME_ENTRIES_LIST_FAILURE";

// Time Entry List / Open
export const TIME_ENTRY_LIST_OPEN = "TIME_ENTRY_LIST_OPEN";
export const TIME_ENTRY_LIST_OPEN_SUCCESS = "TIME_ENTRY_LIST_OPEN_SUCCESS";
export const TIME_ENTRY_LIST_OPEN_FAILURE = "TIME_ENTRY_LIST_OPEN_FAILURE";

// Time Entry Start
export const TIME_ENTRY_START = "TIME_ENTRY_START";
export const TIME_ENTRY_START_SUCCESS = "TIME_ENTRY_START_SUCCESS";
export const TIME_ENTRY_START_FAILURE = "TIME_ENTRY_START_FAILURE";

// Time Entry Stop
export const TIME_ENTRY_STOP = "TIME_ENTRY_STOP";
export const TIME_ENTRY_STOP_SUCCESS = "TIME_ENTRY_STOP_SUCCESS";
export const TIME_ENTRY_STOP_FAILURE = "TIME_ENTRY_STOP_FAILURE";

// Time Entry Search by staff ID
export const TIME_ENTRY_SEARCH_BY_STAFF_ID = "TIME_ENTRY_SEARCH_BY_STAFF_ID";
export const TIME_ENTRY_SEARCH_BY_STAFF_ID_SUCCESS =
  "TIME_ENTRY_SEARCH_BY_STAFF_ID_SUCCESS";
export const TIME_ENTRY_SEARCH_BY_STAFF_ID_FAILURE =
  "TIME_ENTRY_SEARCH_BY_STAFF_ID_FAILURE";

// Time Entry Types

// Get Time Entry Type List
export const GET_TIME_ENTRY_TYPE_LIST = "GET_TIME_ENTRY_TYPE_LIST";
export const GET_TIME_ENTRY_TYPE_LIST_SUCCESS =
  "GET_TIME_ENTRY_TYPE_LIST_SUCCESS";
export const GET_TIME_ENTRY_TYPE_LIST_FAILURE =
  "GET_TIME_ENTRY_TYPE_LIST_FAILURE";

// Time Entries Single Entry Update
export const TIME_ENTRY_SINGLE_ENTRY_UPDATE = "TIME_ENTRY_SINGLE_ENTRY_UPDATE";
export const TIME_ENTRY_SINGLE_ENTRY_UPDATE_SUCCESS =
  "TIME_ENTRY_SINGLE_ENTRY_UPDATE_SUCCESS";
export const TIME_ENTRY_SINGLE_ENTRY_UPDATE_FAILURE =
  "TIME_ENTRY_SINGLE_ENTRY_UPDATE_FAILURE";

// Time Entry Search with Today's Date
export const TIME_ENTRY_SEARCH_WITH_TODAYS_DATE =
  "TIME_ENTRY_SEARCH_WITH_TODAYS_DATE";
export const TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_SUCCESS =
  "TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_SUCCESS";
export const TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_FAILURE =
  "TIME_ENTRY_SEARCH_WITH_TODAYS_DATE_FAILURE";

// Time Entry Redux State Data
export const TIME_ENTRY_REDUX_STATE_DATA = "TIME_ENTRY_REDUX_STATE_DATA";
export const TIME_ENTRY_REDUX_STATE_DATA_SUCCESS =
  "TIME_ENTRY_REDUX_STATE_DATA_SUCCESS";
export const TIME_ENTRY_REDUX_STATE_DATA_FAILURE =
  "TIME_ENTRY_REDUX_STATE_DATA_FAILURE";

// Timer Is Running
export const TIMER_IS_RUNNING = "TIMER_IS_RUNNING";
export const TIMER_IS_RUNNING_SUCCESS = "TIMER_IS_RUNNING_SUCCESS";
export const TIMER_IS_RUNNING_FAILURE = "TIMER_IS_RUNNING_FAILURE";

// Timer Staff_Id
export const TIMER_STAFF_ID = "TIMER_STAFF_ID";
export const TIMER_STAFF_ID_SUCCESS = "TIMER_STAFF_ID_SUCCESS";
export const TIMER_STAFF_ID_FAILURE = "TIMER_STAFF_ID_FAILURE";

//Timer TimeEntryStartDateTime
export const TIMER_TIME_ENTRY_START_DATE_TIME =
  "TIMER_TIME_ENTRY_START_DATE_TIME";
export const TIMER_TIME_ENTRY_START_DATE_TIME_SUCCESS =
  "TIMER_TIME_ENTRY_START_DATE_TIME_SUCCESS";
export const TIMER_TIME_ENTRY_START_DATE_TIME_FAILURE =
  "TIMER_TIME_ENTRY_START_DATE_TIME_FAILURE";

//Timer TimeEntryEndDateTime
export const TIMER_TIME_ENTRY_END_DATE_TIME = "TIMER_TIME_ENTRY_END_DATE_TIME";
export const TIMER_TIME_ENTRY_END_DATE_TIME_SUCCESS =
  "TIMER_TIME_ENTRY_END_DATE_TIME_SUCCESS";
export const TIMER_TIME_ENTRY_END_DATE_TIME_FAILURE =
  "TIMER_TIME_ENTRY_END_DATE_TIME_FAILURE";

//Timer Job_Id
export const TIMER_JOB_ID = "TIMER_JOB_ID";
export const TIMER_JOB_ID_SUCCESS = "TIMER_JOB_ID_SUCCESS";
export const TIMER_JOB_ID_FAILURE = "TIMER_JOB_ID_FAILURE";

// Timer TimeEntryTypeUnbillable_Id
export const TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID =
  "TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID";
export const TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_SUCCESS =
  "TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_SUCCESS";
export const TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_FAILURE =
  "TIMER_TIME_RECORD_TYPE_UNBILLABLE_ID_FAILURE";

//Timer BillableType
export const TIMER_BILLABLE_TYPE = "TIMER_BILLABLE_TYPE";
export const TIMER_BILLABLE_TYPE_SUCCESS = "TIMER_BILLABLE_TYPE_SUCCESS";
export const TIMER_BILLABLE_TYPE_FAILURE = "TIMER_BILLABLE_TYPE_FAILURE";

//Timer Notes
export const TIMER_NOTES = "TIMER_NOTES";
export const TIMER_NOTES_SUCCESS = "TIMER_NOTES_SUCCESS";
export const TIMER_NOTES_FAILURE = "TIMER_NOTES_FAILURE";

// Time Active Tab
export const TIME_ACTIVE_TAB = "TIME_ACTIVE_TAB";
export const TIME_ACTIVE_TAB_SUCCESS = "TIME_ACTIVE_TAB_SUCCESS";
export const TIME_ACTIVE_TAB_FAILURE = "TIME_ACTIVE_TAB_FAILURE";

// Pause Timer
export const PAUSE_TIMER = "PAUSE_TIMER";
export const PAUSE_TIMER_SUCCESS = "PAUSE_TIMER_SUCCESS";
export const PAUSE_TIMER_FAILURE = "PAUSE_TIMER_FAILURE";

// Add Product ID
export const ADD_PRODUCT_ID = "ADD_PRODUCT_ID";
export const ADD_PRODUCT_ID_SUCCESS = "ADD_PRODUCT_ID_SUCCESS";
export const ADD_PRODUCT_ID_FAILURE = "ADD_PRODUCT_ID_FAILURE";

// Add New Time Entry Non Billable Type
export const ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE =
  "ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE";
export const ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS =
  "ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS";
export const ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE =
  "ADD_NEW_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE";

// Delete Time Entry Non Billable Type
export const DELETE_TIME_ENTRY_NON_BILLABLE_TYPE =
  "DELETE_TIME_ENTRY_NON_BILLABLE_TYPE";
export const DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS =
  "DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS";
export const DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE =
  "DELETE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE";

// Update Time Entry Non Billable Type
export const UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE =
  "UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE";
export const UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS =
  "UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_SUCCESS";
export const UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE =
  "UPDATE_TIME_ENTRY_NON_BILLABLE_TYPE_FAILURE";

// Delete selected time entries
export const DELETE_SELECTED_TIME_ENTRIES = "DELETE_SELECTED_TIME_ENTRIES";
export const DELETE_SELECTED_TIME_ENTRIES_SUCCESS =
  "DELETE_SELECTED_TIME_ENTRIES_SUCCESS";
export const DELETE_SELECTED_TIME_ENTRIES_FAILURE =
  "DELETE_SELECTED_TIME_ENTRIES_FAILURE";

//Action Event Fired
export const ACTION_EVENT_FIRED = "ACTION_EVENT_FIRED";
export const ACTION_EVENT_FIRED_SUCCESS = "ACTION_EVENT_FIRED_SUCCESS";
export const ACTION_EVENT_FIRED_FAILURE = "ACTION_EVENT_FIRED_FAILURE";

///timeentry/list/summary/daily
export const TIME_ENTRY_LIST_SUMMARY_DAILY = "TIME_ENTRY_LIST_SUMMARY_DAILY";
export const TIME_ENTRY_LIST_SUMMARY_DAILY_SUCCESS =
  "TIME_ENTRY_LIST_SUMMARY_DAILY_SUCCESS";
export const TIME_ENTRY_LIST_SUMMARY_DAILY_FAILURE =
  "TIME_ENTRY_LIST_SUMMARY_DAILY_FAILURE";
///timeentry/create
export const TIME_ENTRY_CREATE = "TIME_ENTRY_CREATE";
export const TIME_ENTRY_CREATE_SUCCESS = "TIME_ENTRY_CREATE_SUCCESS";
export const TIME_ENTRY_CREATE_FAILURE = "TIME_ENTRY_CREATE_FAILURE";

///timeentry/list/summary/daily/byactivity
export const TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY =
  "TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY";
export const TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_SUCCESS =
  "TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_SUCCESS";
export const TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_FAILURE =
  "TIME_ENTRY_LIST_SUMMARY_DAILY_BY_ACTIVITY_FAILURE";
